<h2 class="text-muted text-xs-center">Top Payers</h2>
<hr>

<div class="card flex flex-row flex-wrap gap-3">
  <label class="d-flex align-items-center fw-bold">From</label>
  <p-calendar [(ngModel)]="from" />
  <label class="d-flex align-items-center fw-bold">to</label>
  <p-calendar [(ngModel)]="to" />
  <p-button icon="pi pi-search" [raised]="true" [loading]="loading" [disabled]="loading" (click)="load()" label="Search" styleClass="p-button-outlined"/>
</div>

<p-messages *ngIf="errorMessage" [(value)]="errorMessage" [closable]="false" />

<div class="card">
  <p-table
    [value]="topPayers"
    dataKey="id"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width:15rem">
          <div class="flex align-items-center">
            Name
          </div>
        </th>
        <th style="min-width:15rem">
          <div class="flex align-items-center">
            Total
          </div>
        </th>
        <th style="min-width:15rem">
          <div class="flex align-items-center">
            Children
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-customer>
      <tr>
        <td>
          {{ customer.name }}
        </td>
        <td>
          ${{ customer.total }}
        </td>
        <td>
          {{ customer.childrenAge }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">No paying parents were found for this period.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
